var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubbleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "#000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.757 3.65H6.193A3.243 3.243 0 002.95 6.893V19.694l3.16-2.622a1.621 1.621 0 011.035-.373h10.612A3.243 3.243 0 0021 13.456V6.893a3.243 3.243 0 00-3.243-3.243z",
    strokeWidth: 1.4249999999999998
  })));
}
export default SvgChatBubbleOutline;